import { RefObject } from 'react';

import { Button } from '@hh.ru/magritte-ui';
import { EllipsisVerticalOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

const TrlKeys = {
    ariaLabel: 'resume.card.action.additional.ariaLabel',
};

interface Props {
    menuActivatorRef: RefObject<HTMLButtonElement>;
    toggleMenuVisible: () => void;
}

const AdditionalButton: TranslatedComponent<Props> = ({ menuActivatorRef, toggleMenuVisible, trls }) => {
    return (
        <Button
            ref={menuActivatorRef}
            size="small"
            mode="secondary"
            icon={<EllipsisVerticalOutlinedSize16 />}
            hideLabel
            onClick={toggleMenuVisible}
            aria-label={trls[TrlKeys.ariaLabel]}
            data-qa="response-additional-trigger"
        />
    );
};

export default translation(AdditionalButton);
